import { MAIN_STORE_ROUTE_KEYS } from './constants';
import { PermissionType } from 'models/permission.model';
import { VIEW_PERMISSION_ACTIONS, hasPermission } from './authorization';
import { RouteModuleBinding, getRouteModuleBinding } from './route-module-map';

export type RouteAuthorizationRule = RouteModuleBinding;

export const getRouteAuthorizationRule = (pathname: string): RouteAuthorizationRule | undefined => {
  return getRouteModuleBinding(pathname);
};

export const canAccessRoute = (
  pathname: string,
  permissions: PermissionType[] = [],
  options?: { requireMappedRule?: boolean }
) => {
  if (!permissions.length) return true;
  const rule = getRouteAuthorizationRule(pathname);
  if (!rule) return options?.requireMappedRule ? false : true;
  return hasPermission(permissions, rule.module, VIEW_PERMISSION_ACTIONS);
};

export const getDefaultAuthorizedRoute = (permissions: PermissionType[] = []) => {
  const preferredRoutes = [
    MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK,
    MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK,
    MAIN_STORE_ROUTE_KEYS.PROCUREMENT,
    MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT,
    MAIN_STORE_ROUTE_KEYS.PREP_REQUESTS,
    MAIN_STORE_ROUTE_KEYS.MANAGE_REQUESTS,
    MAIN_STORE_ROUTE_KEYS.EXECUTIVE_PROCUREMENTS
  ];

  return (
    preferredRoutes.find((route) =>
      canAccessRoute(route, permissions, { requireMappedRule: true })
    ) ?? MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD
  );
};
